<template>
  <svg :width="`${width}px`" :height="`${height}px`">
    <path d="m18.84067,3.03468l-3.67058,0c-0.1831,-1.58776 -1.53399,-2.82521 -3.17011,-2.82521c-1.63606,0 -2.98676,1.23739 -3.16986,2.82521l-3.67078,0c-1.48546,0 -2.69381,1.20871 -2.69381,2.69411l0,0.13823c0,1.13513 0.7068,2.10672 1.70248,2.5026l0,12.7268c0,1.48546 1.2085,2.69411 2.69387,2.69411l10.2763,0c1.48541,0 2.69381,-1.20875 2.69381,-2.69411l0,-12.72674c0.99563,-0.39593 1.70248,-1.36751 1.70248,-2.5026l0,-0.13823c0,-1.48546 -1.20846,-2.69415 -2.69381,-2.69415l0.00001,-0.00001zm-6.84068,-1.54753c0.93053,0 1.70722,0.66696 1.87909,1.54753l-3.75783,0c0.17182,-0.88063 0.94856,-1.54753 1.87875,-1.54753l-0.00001,0zm6.55434,19.60927c0,0.781 -0.63544,1.41649 -1.41619,1.41649l-10.2763,0c-0.78075,0 -1.41619,-0.63553 -1.41619,-1.41649l0,-12.53528l13.10869,0l0,12.53528l-0.00001,0zm1.70248,-15.22938c0,0.781 -0.63544,1.41649 -1.41619,1.41649l-13.68127,0c-0.78075,0 -1.41619,-0.63549 -1.41619,-1.41649l0,-0.13823c0,-0.781 0.63544,-1.41649 1.41619,-1.41649l13.68132,0c0.78075,0 1.41619,0.63549 1.41619,1.41649l0,0.13823l-0.00005,0z" id="svg_3"/>
    <path d="m8.57498,20.87894c0.35282,0 0.6388,-0.2861 0.6388,-0.63876l0,-7.19286c0,-0.35272 -0.28604,-0.63886 -0.6388,-0.63886c-0.35276,0 -0.6388,0.28614 -0.6388,0.63886l0,7.19286c-0.00005,0.35276 0.28599,0.63876 0.6388,0.63876z" id="svg_4"/>
    <path d="m11.99999,20.87894c0.35282,0 0.63886,-0.2861 0.63886,-0.63876l0,-7.19286c0,-0.35272 -0.28614,-0.63886 -0.63886,-0.63886c-0.35276,0 -0.6388,0.28614 -0.6388,0.63886l0,7.19286c0,0.35276 0.28599,0.63876 0.6388,0.63876z" id="svg_5"/>
    <path d="m15.42499,20.87894c0.35276,0 0.63876,-0.2861 0.63876,-0.63876l0,-7.19286c0,-0.35272 -0.28604,-0.63886 -0.63876,-0.63886c-0.35287,0 -0.63886,0.28614 -0.63886,0.63886l0,7.19286c-0.00005,0.35276 0.2861,0.63876 0.63886,0.63876z" id="svg_6"/>  
  </svg>
</template>

<script>
export default {
  name: 'Trash',
  props: {
    width: {
      default: 24,
      type: Number
    },
    height: {
      default: 24,
      type: Number
    },   
  },
}
</script>


<style scoped lang="scss">
svg {
  stroke: #2c3e50;
  stroke-width: 1;
}
</style>
